<template>
  <el-dialog
    class="add_m_dialog"
    :id="$options.name"
    :fullscreen="dialogFullscreen"
    :visible.sync="dialog"
    :before-close="noDialog"
    title="新增充电包月用户"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    top="6vh"
  >
    <div class="add_wrapper">
      <div class="add_step">
        <el-steps
          :direction="isMobile ? 'horizontal' : 'vertical'"
          :active="stepActive"
          :align-center="isMobile"
        >
          <el-step title="选择用户"></el-step>
          <el-step title="选择套餐"></el-step>
          <el-step title="开通包月"></el-step>
        </el-steps>
      </div>
      <div class="add_content">
        <div class="choose_user" v-show="stepActive == 1">
          <div class="choose_user_search">
            <el-row :gutter="5" class="search_header">
              <el-form ref="params" :model="params">
                <el-col :span="5" :xs="24">
                  <el-input v-model="params.id" placeholder="用户编号">
                  </el-input>
                </el-col>
                <el-col :span="5" :xs="24">
                  <el-input v-model="params.nickName" placeholder="用户昵称">
                  </el-input>
                </el-col>
                <el-col :span="5" :xs="24">
                  <el-input v-model="params.phone" placeholder="手机号码">
                  </el-input>
                </el-col>
                <el-col :span="3" :xs="12" class="header_btn">
                  <el-button type="primary" @click="handleSearchUser"
                    >搜索</el-button
                  >
                </el-col>
                <el-col :span="3" :xs="12" class="header_btn">
                  <el-button plain type="success" @click="handleResetParams"
                    >重置</el-button
                  >
                </el-col>
              </el-form>
            </el-row>
            <div class="search_body">
              <div class="body_no_user" v-if="notUser">暂无数据</div>
              <div class="body_user">
                <div
                  class="user_card"
                  title="单击选择"
                  v-for="item in userList"
                  :key="item.id"
                >
                  <user-mini-card
                    :user="item"
                    showChecked
                    :checked="isUserChecked(item)"
                    @checked="handleUserChecked"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="choose_user_checked">
            <div class="checked_title">
              已选择用户({{ checkedUserList.length }})
            </div>
            <div class="checked_box">
              <div
                class="checked_user_card"
                v-for="item in checkedUserList"
                :key="item.id"
              >
                <user-mini-card
                  :user="item"
                  showRemove
                  @remove="handleRemoveUser"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="choose_monthly" v-show="stepActive == 2">
          <el-form
            ref="params"
            :model="monthForm"
            :validate-event="false"
            label-width="110px"
          >
            <el-form-item label="包月小区">
              <el-select
                v-model="groupId"
                :loading="loading"
                filterable
                ref="select"
                @focus="closeReadOnly"
                @hook:mounted="closeReadOnly"
                @visible-change="closeReadOnly"
                placeholder="请输入小区名称"
                @change="handleDeviceGroupChange"
              >
                <el-option
                  v-for="(item, index) in options"
                  :key="index"
                  :label="item.groupName"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="包月套餐" prop="monthlyInfoId">
              <el-select
                v-model="monthForm.monthlyInfoId"
                :disabled="checked"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in monthlyInfoList"
                  :key="item.id"
                  :label="
                    item.money +
                    '元' +
                    ' \/ ' +
                    item.freeChargeNum +
                    '小时，最大功率' +
                    item.endPower +
                    'W'
                  "
                  :value="item.id"
                >
                  <span>{{
                    item.money +
                    "元" +
                    " \/ " +
                    item.freeChargeNum +
                    "小时，最大功率" +
                    item.endPower +
                    "W"
                  }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="包月数量">
              <el-input-number
                v-model="monthForm.openMonthNum"
                :min="1"
                :max="12"
              ></el-input-number>
              个月
            </el-form-item>
          </el-form>
        </div>
        <div class="open_monthly" v-show="stepActive == 3">
          <el-divider content-position="center">
            <span class="monthly_title">包月详情</span>
          </el-divider>
          <div class="monthly_row">
            <span>包月人数：</span>{{ checkedUserList.length }} 人
          </div>
          <div class="monthly_row">
            <span>包月小区：</span>{{ chargeMonthlyArea }}
          </div>
          <div class="monthly_row">
            <span>包月套餐：</span>{{ chargeMonthlyInfo }}
          </div>
          <div class="monthly_row">
            <span>包月数量：</span>{{ monthForm.openMonthNum }} 个月
          </div>
        </div>
      </div>
    </div>

    <div slot="footer">
      <el-button v-if="stepActive > 1" @click="handlePreClick"
        >上一步</el-button
      >
      <el-button v-if="stepActive < 3" type="primary" @click="handleNextClick"
        >下一步</el-button
      >
      <el-button v-if="stepActive == 3" type="primary" @click="addPost"
        >确认开通</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import agentGetOnlyChargeDeviceGroupIdNameList from "@/api/device/device-group-manage/agentGetOnlyChargeDeviceGroupIdNameList";
import agentOpenedAVipForWeChatBatch from "@/api/device/member-monthly-manage/agentOpenedAVipForWeChatBatch";
import getMonthlyByDeviceGroupId from "@/api/device/monthly-manage/getMonthlyByDeviceGroupId";
import agentGetAllUserList from "@/api/user/agentGetAllUserList";
import UserMiniCard from "@/components/UserMiniCard";
import dialogMixin from "@/mixin/dialogMixin";
import isMobileMixin from "@/mixin/isMobileMixin";
import resDisposeMixin from "@/mixin/resDisposeMixin";
import { Loading, Message } from "element-ui";

export default {
  name: "addChargeMonthlyUserDialog",
  mixins: [dialogMixin, resDisposeMixin, isMobileMixin],
  components: {
    UserMiniCard,
  },
  props: {
    dialog: Boolean,
  },
  data() {
    return {
      rules: {
        monthlyInfoId: [{ required: true, message: "请选择包月套餐" }],
      },
      monthForm: {
        monthlyInfoId: undefined,
        openMonthNum: 1,
      },
      stepActive: 1,
      params: {
        id: undefined,
        nickName: undefined,
        phone: undefined,
      },
      monthlyInfoList: [
        {
          id: null,
          freeDayNum: null,
          freeChargeNum: null,
          startPower: null,
          endPower: null,
          money: null,
        },
      ],
      groupId: undefined,
      loading: false,
      checked: true,
      options: [],
      userList: [], // 搜索的用户列表
      checkedUserList: [], // 已选择用户列表
      notUser: true,
    };
  },
  computed: {
    isUserChecked() {
      return (user) => !!this.checkedUserList.find((c) => c.id == user.id);
    },
    chargeMonthlyArea() {
      const obj = this.options.find((o) => o.id == this.groupId);
      return obj ? obj.groupName : "";
    },
    chargeMonthlyInfo() {
      const obj = this.monthlyInfoList.find(
        (o) => o.id == this.monthForm.monthlyInfoId
      );
      return obj
        ? `${obj.money}元 / ${obj.freeChargeNum}小时，最大功率${obj.endPower}W`
        : "";
    },
  },
  watch: {
    dialog(newValue) {
      if (newValue === true) {
        //
      }
    },
    params: {
      handler(newValue) {
        Object.keys(newValue).map((key) => {
          if (newValue[key]) this.$set(this.params, key, newValue[key].trim());
        });
      },
      deep: true,
    },
  },
  methods: {
    closeReadOnly(value) {
      this.$nextTick(() => {
        if (!value) {
          const { select } = this.$refs;
          const input = select.$el.querySelector(".el-input__inner"); 
          input.removeAttribute("readonly"); 
          // this.$refs.select.blur();  根据tip自行判断是否添加
        }
      });
    },
    handleDeviceGroupChange(val) {
      getMonthlyByDeviceGroupId(val).then((res) => {
        if (res.data.length === 0) {
          this.monthlyInfoList = [
            {
              id: null,
              freeDayNum: null,
              freeChargeNum: null,
              startPower: null,
              endPower: null,
              money: null,
            },
          ];
          this.monthForm.monthlyInfoId = undefined;
          this.checked = true;
        } else {
          this.monthlyInfoList = res.data;
          this.checked = false;
        }
      });
    },
    fetchGroup(query) {
      if (query !== "") {
        this.loading = true;
        agentGetOnlyChargeDeviceGroupIdNameList({ name: query }).then((res) => {
          this.options = res.data;
          this.loading = false;
        });
      } else {
        this.options = [];
      }
    },
    // 开通套餐
    addPost() {
      this.loadStart();
      agentOpenedAVipForWeChatBatch({
        userList: this.checkedUserList.map((item) => ({
          memberType: item.memberType,
          memberId: +item.id.split(",")[1],
        })),
        monthlyInfoId: this.monthForm.monthlyInfoId,
        openMonthNum: this.monthForm.openMonthNum,
      })
        .then((res) => {
          this.resNoDialog({ res });
        })
        .finally(() => {
          this.loadDialog.close();
        });
    },
    // 上一步
    handlePreClick() {
      this.stepActive--;
    },
    // 下一步
    handleNextClick() {
      // 是否选择了用户
      if (this.stepActive == 1) {
        if (!this.checkedUserList.length) {
          return Message.error("请先通过搜索选择用户~");
        }
        this.fetchGroup();
      }
      // 是否选择了套餐
      if (this.stepActive == 2) {
        if (!this.monthForm.monthlyInfoId) {
          return Message.error("请先选择套餐~");
        }
      }

      this.stepActive++;
    },
    // 获取用户列表
    fetchData() {
      if (Object.keys(this.params).some((k) => this.params[k])) {
        let loadingInstance = Loading.service({
          target: ".body_no_user",
          fullscreen: false,
        });
        agentGetAllUserList(this.params).then((res) => {
          this.userList = res.data.map((d) => ({
            ...d,
            id: `${d.memberType},${d.id}`,
            platform: d.memberType == "7" ? "支付宝" : "微信",
          }));
          this.notUser = this.userList.length === 0;
          this.$nextTick(() => {
            loadingInstance.close();
          });
        });
      }
    },
    handleSearchUser() {
      this.fetchData();
    },
    handleResetParams() {
      this.params = {
        id: undefined,
        nickName: undefined,
        phone: undefined,
      };
      this.userList = [];
      this.notUser = true;
    },
    handleUserChecked(user) {
      if (!this.checkedUserList.find((c) => c.id == user.id)) {
        this.checkedUserList.push(user);
      }
      Message.success("用户已选中~");
    },
    handleRemoveUser(user) {
      const rI = this.checkedUserList.findIndex((c) => c.id == user.id);
      if (rI >= 0) {
        this.checkedUserList.splice(rI, 1);
        Message.success("用户已移除~");
      }
    },
  },
};
</script>

<style lang="scss">
@import "src/styles/my";
@include mobile {
  .add_m_dialog {
    .el-dialog__body {
      padding: 20px 8px;
      .add_wrapper {
        display: block !important;
        .add_step {
          margin: 0 0 20px !important;
        }
        .add_content {
          .choose_user {
            .choose_user_search {
              height: 47vh;
              .search_header {
                .header_btn {
                  margin-top: 5px;
                }
              }
              .search_body {
                .body_no_user {
                  margin-top: 45px;
                }
              }
            }
          }
        }
      }
    }
  }
}

$borderColor: #ddd;

.add_wrapper {
  display: flex;
  min-height: 62vh;

  .add_step {
    margin-right: 20px;
  }

  .add_content {
    flex: 1;
    .choose_user {
      width: 100%;
      .choose_user_search {
        box-sizing: border-box;
        border: 1px solid $borderColor;
        margin-bottom: 10px;
        height: 35vh;
        overflow-y: scroll;
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* IE 10+ */

        &::-webkit-scrollbar {
          display: none; /* Chrome Safari */
        }

        .search_header {
          background-color: #f0f0f0 !important;
          padding: 5px;
        }

        .search_body {
          padding: 10px;
          .body_no_user {
            text-align: center;
            margin-top: 100px;
            font-size: 15px;
            color: #aaa;
            letter-spacing: 1px;
          }

          .body_user {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;

            .user_card {
              width: 49%;
              margin-bottom: 12px;
            }
          }
        }
      }

      .choose_user_checked {
        border: 1px solid $borderColor;
        height: 25vh;
        overflow-y: scroll;
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none; /* IE 10+ */

        &::-webkit-scrollbar {
          display: none; /* Chrome Safari */
        }
        .checked_title {
          border-bottom: 1px solid $borderColor;
          background-color: #f0f0f0;
          padding: 5px;
          font-weight: bold;
        }
        .checked_box {
          padding: 10px;
          .checked_user_card {
            margin-bottom: 8px;
          }
        }
      }
    }

    .choose_monthly {
    }

    .open_monthly {
      .monthly_title {
        font-size: 18px;
        font-weight: bold;
      }

      .monthly_row {
        font-size: 16px;
        margin: 15px 0;

        span {
          font-weight: bold;
        }
      }
    }
  }
}
</style>
